/* Copyright (c) 2017 Backpack Health LLC */

import api from 'api';

import actionTypes from 'redux/actions';

import profileActions from 'redux/actions/profile';
import userActions from 'redux/actions/user';
import listActions from 'redux/actions/lists';
import localeActions from 'redux/actions/locale';
import sessionActions from 'redux/actions/session';
import uiStateActions from 'redux/actions/uiState';
import navigationActions from 'redux/actions/navigation';
import groupActions from 'redux/actions/group';
import groupSelectors from 'redux/reduxStore/group';
import userSelectors from 'redux/reduxStore/user';
import listLocaleSelectors from 'redux/reduxStore/lists/listLocale';

import routeNames from 'lib/routeNames';
import CustomerService from 'lib/CustomerService';
import userGroupRole from '../../constants/userGroupRole';

function loadInitialData(subdomain) {
  return (dispatch, getState) => {
    dispatch(listActions.locale.request());
    dispatch(listActions.colorTheme.request());
    dispatch(localeActions.initializeClientLocales());
    dispatch(listActions.country.request());
    dispatch(listActions.residenceCountry.request());
    dispatch(listActions.residenceState.request());

    if (subdomain) {
      dispatch(groupActions.getMetadata(subdomain))
        .catch(apiError => {
          dispatch(sessionActions.logout());
        });
    }
  }
}

function loadRequiredData(profileId) {
  return (dispatch, getState) => {
    const groupId = groupSelectors.getActiveGroup(getState()).id;
    const user = userSelectors.getLoggedInUser(getState());
    const userId = user.id;
    const locale = listLocaleSelectors.getLocale(getState(), user.locale_id);
    let preferredName = '';


    return api.profileApi.get(profileId)
    .then((profile) => {
      preferredName = profile.preferred_name;
      dispatch(profileActions.receive(profile));
      return api.userApi.get(userId);
    }).then(user => {
      dispatch(userActions.receive(user));

      CustomerService.shutdown();
      CustomerService.initUser(
        user.email,
        preferredName,
        user.cuid,
        user.intercom_web_hash,
        locale.language_code
      );

      return null;
    }).then(() => {
      return dispatch(userActions.requestGroupRoles(userId));
    }).then(() => {
      switch (userSelectors.currentRole(getState())) {
        case userGroupRole.VIEWER:
          break;
        default:
          dispatch(groupActions.requestAdmins(groupId));
          break;
      }

      return null;
    }).catch(apiError => {
      dispatch(sessionActions.logout());
      dispatch(navigationActions.goTo(routeNames.home()));
    });

  };
}

const actions = {
  loadInitialData,
  loadRequiredData,
};

export default actions;

